// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid #000099;
  position: fixed;
  width: 100%;
  -webkit-backdrop-filter: blur(24px);
          backdrop-filter: blur(24px);
  z-index: 100;
}

.nav-link {
  text-decoration: none;
  color: #000099;
  margin: 0px 16px;
}

.nav-links > .nav-link {
  margin: 0px 10px;
}

.nav-link:hover {
  text-decoration: line-through;
}

.burger-container {
  display: none;
  width: 120px;
}

@media only screen and (width < 769px) {
  .nav-links {
    display: none;
  }

  .logo:hover {
    text-decoration: line-through;
    color: #000099;
  }

  .burger-container {
    display: flex;
    align-items: flex-start;
  }

  .nav-link {
    color: #faf9f6;
  }

  .bm-menu {
    background: #000099;
    width: 100%;
    padding: 0;
    font-size: 16px;
    height: 100vh !important;
  }
  .bm-menu-wrap {
    width: 120px !important;
    top: 46px;
    height: 100vh !important;
  }

  .bm-item-list {
    color: #faf9f6;
    padding: 8px;
  }

  .bm-item {
    display: inline-block;
  }

  .bm-overlay {
    width: 0 !important;
  }

  .bm-burger-button {
    position: fixed;
    width: 24px;
    height: 24px;
    top: 12px;
    right: 16px;
  }

  .bm-burger-bars {
    background: #000099;
  }

  .bm-burger-bars-hover {
    background: #000099;
  }

  .bm-cross-button,
  .bm-cross {
    display: none;
  }
}
@media only screen and (min-width: 390px) and (max-width: 769px) {
  .bm-menu-wrap {
    top: 91px;
  }

  .bm-menu {
    font-size: 24px;
  }

  .bm-burger-button {
    top: 32px;
  }
  .logo {
    font-size: 32px;
  }
}

@media only screen and (max-width: 390px) {
  .logo {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Nav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,mCAA2B;UAA3B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".nav-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 0.5px solid #000099;\n  position: fixed;\n  width: 100%;\n  backdrop-filter: blur(24px);\n  z-index: 100;\n}\n\n.nav-link {\n  text-decoration: none;\n  color: #000099;\n  margin: 0px 16px;\n}\n\n.nav-links > .nav-link {\n  margin: 0px 10px;\n}\n\n.nav-link:hover {\n  text-decoration: line-through;\n}\n\n.burger-container {\n  display: none;\n  width: 120px;\n}\n\n@media only screen and (width < 769px) {\n  .nav-links {\n    display: none;\n  }\n\n  .logo:hover {\n    text-decoration: line-through;\n    color: #000099;\n  }\n\n  .burger-container {\n    display: flex;\n    align-items: flex-start;\n  }\n\n  .nav-link {\n    color: #faf9f6;\n  }\n\n  .bm-menu {\n    background: #000099;\n    width: 100%;\n    padding: 0;\n    font-size: 16px;\n    height: 100vh !important;\n  }\n  .bm-menu-wrap {\n    width: 120px !important;\n    top: 46px;\n    height: 100vh !important;\n  }\n\n  .bm-item-list {\n    color: #faf9f6;\n    padding: 8px;\n  }\n\n  .bm-item {\n    display: inline-block;\n  }\n\n  .bm-overlay {\n    width: 0 !important;\n  }\n\n  .bm-burger-button {\n    position: fixed;\n    width: 24px;\n    height: 24px;\n    top: 12px;\n    right: 16px;\n  }\n\n  .bm-burger-bars {\n    background: #000099;\n  }\n\n  .bm-burger-bars-hover {\n    background: #000099;\n  }\n\n  .bm-cross-button,\n  .bm-cross {\n    display: none;\n  }\n}\n@media only screen and (min-width: 390px) and (max-width: 769px) {\n  .bm-menu-wrap {\n    top: 91px;\n  }\n\n  .bm-menu {\n    font-size: 24px;\n  }\n\n  .bm-burger-button {\n    top: 32px;\n  }\n  .logo {\n    font-size: 32px;\n  }\n}\n\n@media only screen and (max-width: 390px) {\n  .logo {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
